import { render } from "./org-card.vue?vue&type=template&id=be0fc926"
import script from "./org-card.vue?vue&type=script&setup=true&lang=js"
export * from "./org-card.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/nsi/components/forms/org-structure-form/org-card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "be0fc926"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('be0fc926', __exports__)) {
    api.reload('be0fc926', __exports__)
  }
  
  module.hot.accept("./org-card.vue?vue&type=template&id=be0fc926", () => {
    api.rerender('be0fc926', render)
  })

}


export default __exports__